import PostsCarousel from '../components/postsCarousel'

class PostsCarousels {
	components: PostsCarousel[] = []

	init(container: Document | HTMLElement = document) {
		container.querySelectorAll<HTMLElement>('.hg-posts-carousel').forEach((el) => {
			const component = new PostsCarousel(el)
			component.init()
			this.components.push(component)
		})
	}

	update(container: Document | HTMLElement = document) {
		this.cleanup()
		this.init(container)
	}

	cleanup() {
		this.components.forEach((c) => c.cleanup())
		this.components = []
	}
}

export default new PostsCarousels()
